import { MicrosoftAuthConfig } from '@msal';

export const environment = {
  name: 'develop',
  production: false,
  remoteApi: 'https://app-casino-event-admin-api-dev.azurewebsites.net/api',

  microsoft: {
    clientId: '5e7d690b-eb72-48c5-9338-3c5c02889fdc',
    authority: 'https://login.microsoftonline.com/6a7ef1e2-9e9e-412e-9824-b8c2856ce8f4',
    redirectUri: 'https://msadminapp-dev.bslog.com/',

    protectedResources: [
      {
        url: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['user.read'],
      },
      {
        url: 'https://msadminapp-dev.bslog.com/',
        scopes: ['api://5e7d690b-eb72-48c5-9338-3c5c02889fdc/user_impersonation'],
      },
      {
        url: 'https://app-casino-event-admin-api-dev.azurewebsites.net/',
        scopes: ['api://5e7d690b-eb72-48c5-9338-3c5c02889fdc/user_impersonation'],
      },
    ],

    protectedResourcesDefaultScope: ['api://5e7d690b-eb72-48c5-9338-3c5c02889fdc/user_impersonation'],
  } satisfies MicrosoftAuthConfig,
};
